import { ILegendItem } from "@/models/legend.model";

export enum Sentiment {
  Positive = 'Positive',
  Uncertain = 'Uncertain',
  Neutral = 'Neutral',
  Negative = 'Negative',
}

export interface ISentiment {
  Positive: number;
  Uncertain: number;
  Neutral: number;
  Negative: number;
}

export interface ISentimentTimeline extends ISentiment {
  date: string;
}

export interface ISentimentLegendItem extends ILegendItem{
  percentage: number;
}

export enum SentimentTypes {
  overall = 'Overall',
  peak = 'Peak',
  end = 'End',
}

export enum SentimentChangeIndicatorTypes {
  highlyPositive = 'HighlyPositive',
  positiveTurnaround = 'PositiveTurnaround',
  highlyNegative = 'HighlyNegative',
  negativeTurnaround = 'NegativeTurnaround',
}